import { defineComponent as _defineComponent } from 'vue'
import Action from '@/components/atoms/action/Action.vue';
import Loading from '@/components/atoms/loading/Loading.vue';
import Status from '@/enum/Status';
import moment from 'moment';
import { computed, getCurrentInstance, onMounted, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestDetail',
  setup(__props) {

const instance = getCurrentInstance();
const proxy = instance && instance.proxy as any;

const data = reactive({
    request: null,
    isLoading: true,
    error: false
});

const getDetails = () => {
    if (data.request && data.request.requests_details && data.request.requests_details.length > 0) {
        return data.request.requests_details[0];
    }
    return {};
};

const formatMoney = (value: any) => {
    if (!value) {
        return '-';
    }
    const stringValue = String(value);
    return stringValue.formatMoney ? `$${stringValue.formatMoney()}` : stringValue;
};

const loadRequest = async () => {
    try {
        data.isLoading = true;
        const user: any = await proxy.$root._post(
            'subscriptors/one/' + proxy.$store.state.user.id,
            {
                models: 'companies'
            }
        );

        var company = null;
        if (proxy.$store.state.companyId) {
            var companies = user.data[0].companies;
            for (var i = 0; i < companies.length; i++) {
                if (companies[i].id == proxy.$store.state.companyId) {
                    company = companies[i];
                    break;
                }
            }
        } else {
            company = user.data[0].companies[0];
        }

        const requestData: any = await proxy.$root._post(
            'requests/one/' + proxy.$route.params.id,
            {
                models: 'companies,branches,control_zones,subscriptors,currencies'
            }
        );

        if (company.id !== requestData.data[0].company.id) {
            data.error = true;
            return false;
        }

        data.request = requestData.data[0];
        return true;
    } catch (e) {
        data.error = true;
        proxy.$root.notify('Error al cargar la solicitud', 'error');
        return false;
    } finally {
        data.isLoading = false;
    }
};

const model = computed(() => {
    const details = getDetails();

    const getValue = (field: string) =>
        details && details[field] ? details[field] : 'N/A';

    return {
        isCompleted: data.request && [1, 6].includes(data.request.status),

        policyNumber: getValue('policy_number'),
        assurerName: getValue('insured_fullname'),

        fromDate:
            data.request.validity_from
                ? moment(data.request.validity_from).format('DD/MM/YYYY')
                : '-',

        toDate:
            data.request.validity_to
                ? moment(data.request.validity_to).format('DD/MM/YYYY')
                : '-',

        country: getValue('country'),
        city: getValue('city'),
        address: getValue('address'),
        zipCode: getValue('zip_code'),
        original_tax: getValue('original_tax'),

        floors: getValue('floors'),
        constructionYear: getValue('year_built'),

        beachFront:
            details.beach_front === null || details.beach_front === undefined
                ? 'N/A'
                : details.beach_front
                    ? 'Sí'
                    : 'No',

        building: formatMoney(getValue('building')),
        businessInterruption: formatMoney(getValue('business_interruption')),
        content: formatMoney(getValue('content')),

        totalInsuredValue: (() => {
            const value = getValue('total_sum_secured');
            return value && value !== '-' ? formatMoney(value) : 'N/A';
        })(),
    };
});

const exportPDF = () => {
    const sidebar = document.querySelector('.sidebar') as HTMLElement;
    const header = document.querySelector('header.desktop') as HTMLElement;
    const sections = document.querySelectorAll('.section-actions');
    const menuIcon = document.querySelector('.menu-icon') as HTMLElement;
    const bellIcon = document.querySelector('.bell-icon') as HTMLElement;
    const detailMain = document.querySelector('.app-container') as HTMLElement;
    const detailFooter = document.querySelector('.request-detail footer') as HTMLElement;

    // Ocultar elementos
    sidebar && (sidebar.style.display = 'none');
    header && (header.style.display = 'none');
    detailFooter && (detailFooter.style.display = 'none');
    sections.forEach(ii => (ii as HTMLElement).style.display = 'none');
    menuIcon && (menuIcon.style.display = 'none');
    bellIcon && (bellIcon.style.display = 'none');
    detailMain && (detailMain.style.position = "absolute");
    detailMain && (detailMain.style.top = "0");
    detailMain && (detailMain.style.width = "100%");

    // Restaurar DESPUÉS de imprimir
    window.onafterprint = () => {
        sidebar.removeAttribute('style');
        header.removeAttribute('style');
        detailFooter.removeAttribute('style');
        sections.forEach(ii => ii.removeAttribute('style'));
        menuIcon.removeAttribute('style');
        bellIcon.removeAttribute('style');
        detailMain.removeAttribute('style');
        window.onafterprint = null;
    };

    window.print();
}

const back = () => {
    window.location.href = `/requests/quotes`;
};

const home = () => {
    window.location.href = `/facility/select`;
};

const canQuote = computed(() => {
    return data.request && [Status.Preaprobado, Status.Pendiente].includes(data.request.status);
});

const quote = () => {
    window.location.href = `/requests/${data.request.id}/quote`;
};

onMounted(async () => {
    loadRequest();
});

return { __sfc: true,instance, proxy, data, getDetails, formatMoney, loadRequest, model, exportPDF, back, home, canQuote, quote, Action, Loading }
}

})